import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import elCommon from './locales/el/common.json';
import elEventViewer from './locales/el/event_viewer.json';
import elEvents from './locales/el/events.json';
import elEventsCommon from './locales/el/events_common.json';
import elExclusions from './locales/el/exclusions.json';
import elFilters from './locales/el/filters.json';
import elFleet from './locales/el/fleet.json';
import elInsights from './locales/el/insights.json';
import elLicensePlate from './locales/el/license_plate.json';
import elLogin from './locales/el/login.json';
import elMisc from './locales/el/misc.json';
import elReports from './locales/el/reports.json';
import elReview from './locales/el/review.json';
import elSpotlight from './locales/el/spotlight.json';
import enCommon from './locales/en/common.json';
import enEventViewer from './locales/en/event_viewer.json';
import enEvents from './locales/en/events.json';
import enEventsCommon from './locales/en/events_common.json';
import enExclusions from './locales/en/exclusions.json';
import enFilters from './locales/en/filters.json';
import enFleet from './locales/en/fleet.json';
import enInsights from './locales/en/insights.json';
import enLicensePlate from './locales/en/license_plate.json';
import enLogin from './locales/en/login.json';
import enMisc from './locales/en/misc.json';
import enReports from './locales/en/reports.json';
import enReview from './locales/en/review.json';
import enSpotlight from './locales/en/spotlight.json';
import esCommon from './locales/es/common.json';
import esEventViewer from './locales/es/event_viewer.json';
import esEvents from './locales/es/events.json';
import esEventsCommon from './locales/es/events_common.json';
import esExclusions from './locales/es/exclusions.json';
import esFilters from './locales/es/filters.json';
import esFleet from './locales/es/fleet.json';
import esInsights from './locales/es/insights.json';
import esLicensePlate from './locales/es/license_plate.json';
import esLogin from './locales/es/login.json';
import esMisc from './locales/es/misc.json';
import esReports from './locales/es/reports.json';
import esReview from './locales/es/review.json';
import esSpotlight from './locales/es/spotlight.json';
import frCommon from './locales/fr/common.json';
import frEventViewer from './locales/fr/event_viewer.json';
import frEvents from './locales/fr/events.json';
import frEventsCommon from './locales/fr/events_common.json';
import frExclusions from './locales/fr/exclusions.json';
import frFilters from './locales/fr/filters.json';
import frFleet from './locales/fr/fleet.json';
import frInsights from './locales/fr/insights.json';
import frLicensePlate from './locales/fr/license_plate.json';
import frLogin from './locales/fr/login.json';
import frMisc from './locales/fr/misc.json';
import frReports from './locales/fr/reports.json';
import frReview from './locales/fr/review.json';
import frSpotlight from './locales/fr/spotlight.json';
import itCommon from './locales/it/common.json';
import itEventViewer from './locales/it/event_viewer.json';
import itEvents from './locales/it/events.json';
import itEventsCommon from './locales/it/events_common.json';
import itExclusions from './locales/it/exclusions.json';
import itFilters from './locales/it/filters.json';
import itFleet from './locales/it/fleet.json';
import itInsights from './locales/it/insights.json';
import itLicensePlate from './locales/it/license_plate.json';
import itLogin from './locales/it/login.json';
import itMisc from './locales/it/misc.json';
import itReports from './locales/it/reports.json';
import itReview from './locales/it/review.json';
import itSpotlight from './locales/it/spotlight.json';
import plCommon from './locales/pl/common.json';
import plEventViewer from './locales/pl/event_viewer.json';
import plEvents from './locales/pl/events.json';
import plEventsCommon from './locales/pl/events_common.json';
import plExclusions from './locales/pl/exclusions.json';
import plFilters from './locales/pl/filters.json';
import plFleet from './locales/pl/fleet.json';
import plInsights from './locales/pl/insights.json';
import plLicensePlate from './locales/pl/license_plate.json';
import plLogin from './locales/pl/login.json';
import plMisc from './locales/pl/misc.json';
import plReports from './locales/pl/reports.json';
import plReview from './locales/pl/review.json';
import plSpotlight from './locales/pl/spotlight.json';
import ptCommon from './locales/pt/common.json';
import ptEventViewer from './locales/pt/event_viewer.json';
import ptEvents from './locales/pt/events.json';
import ptEventsCommon from './locales/pt/events_common.json';
import ptExclusions from './locales/pt/exclusions.json';
import ptFilters from './locales/pt/filters.json';
import ptFleet from './locales/pt/fleet.json';
import ptInsights from './locales/pt/insights.json';
import ptLicensePlate from './locales/pt/license_plate.json';
import ptLogin from './locales/pt/login.json';
import ptMisc from './locales/pt/misc.json';
import ptReports from './locales/pt/reports.json';
import ptReview from './locales/pt/review.json';
import ptSpotlight from './locales/pt/spotlight.json';
import { bindDateTimeLocale } from './dateTimeLocale';

import './types';

i18n.use(initReactI18next).init({
  lng: localStorage.getItem('i18nextLng') ?? 'en',
  fallbackLng: 'en',
  defaultNS: 'common',
  resources: {
    en: {
      common: enCommon,
      login: enLogin,
      license_plate: enLicensePlate,
      misc: enMisc,
      spotlight: enSpotlight,
      insights: enInsights,
      reports: enReports,
      fleet: enFleet,
      review: enReview,
      event_viewer: enEventViewer,
      filters: enFilters,
      events: enEvents,
      events_common: enEventsCommon,
      exclusions: enExclusions,
    },
    el: {
      common: elCommon,
      login: elLogin,
      license_plate: elLicensePlate,
      misc: elMisc,
      spotlight: elSpotlight,
      insights: elInsights,
      reports: elReports,
      fleet: elFleet,
      review: elReview,
      event_viewer: elEventViewer,
      filters: elFilters,
      events: elEvents,
      events_common: elEventsCommon,
      exclusions: elExclusions,
    },
    es: {
      common: esCommon,
      login: esLogin,
      license_plate: esLicensePlate,
      misc: esMisc,
      spotlight: esSpotlight,
      insights: esInsights,
      reports: esReports,
      fleet: esFleet,
      review: esReview,
      event_viewer: esEventViewer,
      filters: esFilters,
      events: esEvents,
      events_common: esEventsCommon,
      exclusions: esExclusions,
    },
    pt: {
      common: ptCommon,
      login: ptLogin,
      license_plate: ptLicensePlate,
      misc: ptMisc,
      spotlight: ptSpotlight,
      insights: ptInsights,
      reports: ptReports,
      fleet: ptFleet,
      review: ptReview,
      event_viewer: ptEventViewer,
      filters: ptFilters,
      events: ptEvents,
      events_common: ptEventsCommon,
      exclusions: ptExclusions,
    },
    pl: {
      common: plCommon,
      login: plLogin,
      license_plate: plLicensePlate,
      misc: plMisc,
      spotlight: plSpotlight,
      insights: plInsights,
      reports: plReports,
      fleet: plFleet,
      review: plReview,
      event_viewer: plEventViewer,
      filters: plFilters,
      events: plEvents,
      events_common: plEventsCommon,
      exclusions: plExclusions,
    },
    it: {
      common: itCommon,
      login: itLogin,
      license_plate: itLicensePlate,
      misc: itMisc,
      spotlight: itSpotlight,
      insights: itInsights,
      reports: itReports,
      fleet: itFleet,
      review: itReview,
      event_viewer: itEventViewer,
      filters: itFilters,
      events: itEvents,
      events_common: itEventsCommon,
      exclusions: itExclusions,
    },
    fr: {
      common: frCommon,
      login: frLogin,
      license_plate: frLicensePlate,
      misc: frMisc,
      spotlight: frSpotlight,
      insights: frInsights,
      reports: frReports,
      fleet: frFleet,
      review: frReview,
      event_viewer: frEventViewer,
      filters: frFilters,
      events: frEvents,
      events_common: frEventsCommon,
      exclusions: frExclusions,
    },
  },
  interpolation: {
    escapeValue: false,
  },
});

bindDateTimeLocale(i18n);

export default i18n;
